import { HttpResponse } from '@angular/common/http';

/**
 * Cachad data för backend-service
 */
export class ResultCache {
    constructor(
        public url: string,
        public data: HttpResponse<any>
    ) {}
}
